import React from "react";
import CertificateCard from "../components/Certificate/CertificateCard";
import { MdOutlineNavigateNext, MdOutlineNavigateBefore } from "react-icons/md";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import certi1 from "../assets/certificates/1.webp";
import certi2 from "../assets/certificates/2.webp";
import certi3 from "../assets/certificates/3.webp";
import certi4 from "../assets/certificates/4.webp";
import certi5 from "../assets/certificates/5.webp";
import certi6 from "../assets/certificates/6.webp";
import certi7 from "../assets/certificates/7.webp";
import certi8 from "../assets/certificates/8.webp";

const data = [
  {
    title: "The Complete Javascript  ",
    img: certi1,
    platform: "udemy",
    issued: "dec, 2022",
    credential:
      "https://www.udemy.com/certificate/UC-5d490d54-88c0-49d4-9822-d4630d665623/",
  },
  {
    title: "Python Intermediate ",
    img: certi2,
    platform: "TCS",
    issued: "may, 2020",
    credential:
      "https://drive.google.com/file/d/1wur_zBf2-xEQRVXXS_BelztFINs-T7Y4/view?usp=sharing",
  },
  {
    title: "React Front to back ",
    img: certi3,
    platform: "udemy",
    issued: "may, 2022",
    credential:
      "https://www.udemy.com/certificate/UC-3718f72a-8456-4c8c-975c-f9335bba1df6/",
  },
  {
    title: "Machine Learning",
    img: certi4,
    platform: "Standford university",
    issued: "may, 2022",
    credential:
      "https://www.coursera.org/account/accomplishments/verify/K23BXPP3B42E",
  },
  {
    title: "Build responsive website using html css",
    img: certi5,
    platform: "Udemy",
    issued: "jan, 2022",
    credential:
      "https://www.udemy.com/certificate/UC-d15f525d-71ab-45b3-bc58-1e699465d5af/",
  },
  {
    title: "Sql & Postgre-sql for beginners",
    img: certi6,
    platform: "Udemy",
    issued: "jul, 2021",
    credential:
      "https://www.udemy.com/certificate/UC-25c4dad7-b619-496c-8ea6-1edbe7556055/",
  },
  {
    title: "Machine learning a-z",
    img: certi7,
    platform: "Udemy",
    issued: "feb, 2021",
    credential:
      "https://www.udemy.com/certificate/UC-ea51de66-0c27-4a8b-b49f-c2fde59d57ab/",
  },
  {
    title: "Complete Python bootcamp",
    img: certi8,
    platform: "Udemy",
    issued: "apr, 2020",
    credential:
      "https://www.udemy.com/certificate/UC-64faf8fa-15db-42ad-8d55-c9d4ac8df81a/",
  },
];
function Certificates() {
  const [page, setPage] = useState(0);
  const [dir, setDir] = useState("right");
  const [noItems, setNoItems] = useState(1);
  const pages = Math.ceil(data.length / noItems);
  const startIndx = page * noItems;
  const endIndx = page * noItems + noItems;

  const windowSizeHandler = () => {
    if (window.innerWidth <= 640) setNoItems(1);
    else if (window.innerWidth <= 1024) setNoItems(2);
    else setNoItems(4);
  };
  window.onresize = windowSizeHandler;
  window.onload = windowSizeHandler;

  // useEffect(() => {
  //   const intrvl = setInterval(() => {
  //     setPage((page) => (page + 1) % pages);
  //   }, 3000);
  //   return () => clearInterval(intrvl);
  // });

  const rightClickHandler = () => {
    setDir("right");
    setPage((prev) => prev + 1);
  };
  const leftClickHandler = () => {
    setDir("left");
    setPage((prev) => prev - 1);
  };

  //animations
  const variantsRight = {
    initial: {
      x: "150%",
      opacity: 0.5,
    },
    animate: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.7,
      },
    },
    exit: {
      x: "-150%",
      opacity: 0,
    },
  };
  const variantsLeft = {
    initial: {
      x: "-150%",
      opacity: 0.5,
    },
    animate: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.7,
      },
    },
    exit: {
      x: "150%",
      opacity: 0,
      transition: "ease-out",
    },
  };
  window.console.log(pages);

  return (
    <section id="certificates">
      <div className="section__title">Certificates</div>
      <div className="container px-3 lg:px-0">
        <AnimatePresence initial={false}>
          <div className="w-full h-full relative ">
            <div
              className={`slider relative w-full rounded-lg  px-8 pb-12 pt-36 flex flex-col justify-center items-center bg-containerColor dark:bg-darkContainerColor overflow-hidden`}
            >
              <div
                className="flex flex-row justify-around items-center w-full gap-8 transition-all duration-1000 "
                // style={{ transform: `translateX(-${transX}%)` }}
              >
                {data.slice(startIndx, endIndx).map((item, indx) => (
                  <motion.div
                    className="flex items-center justify-center w-full"
                    key={startIndx + indx}
                    initial="initial"
                    exit="exit"
                    animate="animate"
                    variants={dir === "left" ? variantsLeft : variantsRight}
                  >
                    <CertificateCard
                      title={item.title}
                      platform={item.platform}
                      img={item.img}
                      issued={item.issued}
                      credential={item.credential}
                    />
                  </motion.div>
                ))}
              </div>

              <div className="slideIndicator pt-8 flex gap-2 items-center lg:cursor-pointer">
                {[...Array(pages).keys()].map((item) => (
                  <div
                    onClick={() => setPage(item)}
                    className={`w-3 h-3 relative rounded-full border-2 border-leetcodeBorderColor
                  ${
                    item === page
                      ? "before:w-1/2 before:h-1/2  before:absolute before:rounded-full before:bg-leetcodeBorderColor before:left-1/2 before:right-1/2 before:-translate-x-1/2 before:translate-y-1/2"
                      : ""
                  }
                  `}
                  ></div>
                ))}
              </div>
            </div>
            <button
              className={`flex justify-center items-center w-10 h-10 lg:w-14 lg:h-14 rounded-full border-2 border-leetcodeBorderColor absolute top-1/2 left-0 -translate-x-1/2
           -translate-y-1/2 bg-containerColor dark:bg-darkContainerColor cursor-none lg:cursor-pointer ${
             page === 0 ? "opacity-40" : ""
           }`}
              onClick={leftClickHandler}
              disabled={page === 0}
            >
              <MdOutlineNavigateBefore className="text-leetcodeBorderColor font-bold text-3xl" />
            </button>
            <button
              className={`flex justify-center items-center w-10 h-10 lg:w-14 lg:h-14 rounded-full border-2 border-leetcodeBorderColor absolute top-1/2 right-0 translate-x-1/2
           -translate-y-1/2 bg-containerColor dark:bg-darkContainerColor cursor-none lg:cursor-pointer ${
             page === pages - 1 ? "opacity-40" : ""
           }`}
              onClick={rightClickHandler}
              disabled={page === pages - 1}
            >
              <MdOutlineNavigateNext className="text-leetcodeBorderColor font-bold text-3xl" />
            </button>
          </div>
        </AnimatePresence>
      </div>
    </section>
  );
}

export default Certificates;
